import { SchemaOf, object, string, boolean, number } from 'yup';

import { BackupLocalSettings } from './types';
import { CRON_RULE_REGEX } from './cron-validation';

export function validationSchema(): SchemaOf<BackupLocalSettings> {
  return object({
    scheduleAutomaticBackup: boolean().default(false),
    cronRule: string()
      .default('')
      .when('scheduleAutomaticBackup', {
        is: true,
        then: (schema) =>
          schema.required('This field is required.').when('cronRule', {
            is: (val: string) => val !== '',
            then: (schema) =>
              schema.matches(
                CRON_RULE_REGEX,
                'Please enter a valid cron rule.'
              ),
          }),
      }),
    retentionDays: number()
      .default(0)
      .min(0, 'Retention days must be zero or positive.')
      .integer('Retention days must be a whole number.'),
  });
}
